if (!customElements.get('fls-product-reviews')) {
  customElements.define('fls-product-reviews', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.fls-reviews__viewport');
      this.slides = [...this.querySelectorAll('.fls-reviews__card')];
      this.previous = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.pagination = this.querySelector('[data-review-dots]');
      this.status = this.querySelector('[data-review-status]');
      if (!this.viewport || !this.slides.length) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = 0;
      this.dots = this.slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fls-reviews__dot';
        dot.setAttribute('aria-label', `Ver reseña ${index + 1} de ${this.slides.length}`);
        dot.setAttribute('aria-controls', slide.id);
        dot.addEventListener('click', () => this.goTo(index), options);
        return dot;
      });
      this.pagination.replaceChildren(...this.dots);
      this.pagination.hidden = this.slides.length < 2;
      if (this.previous && this.next) {
        this.previous.hidden = false;
        this.next.hidden = false;
        this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
        this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
      }
      this.viewport.addEventListener('keydown', (event) => {
        // Let links and review details keep their native keyboard behavior.
        if (event.target !== this.viewport) return;
        const indices = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in indices)) return;
        event.preventDefault();
        this.goTo(indices[event.key]);
      }, options);
      this.viewport.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.syncFromScroll(), 100);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.goTo(this.index, false));
      this.resizeObserver.observe(this.viewport);
      this.renderState(false);
    }

    goTo(index, animate = true) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.viewport.scrollTo({
        left: this.slides[target].offsetLeft,
        behavior: animate && !reducedMotion ? 'smooth' : 'instant',
      });
      this.index = target;
      this.renderState(animate);
    }

    syncFromScroll() {
      let nearest = 0;
      this.slides.forEach((slide, index) => {
        if (Math.abs(slide.offsetLeft - this.viewport.scrollLeft) < Math.abs(this.slides[nearest].offsetLeft - this.viewport.scrollLeft)) nearest = index;
      });
      if (nearest === this.index) return;
      this.index = nearest;
      this.renderState(true);
    }

    renderState(announce) {
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.index;
        slide.setAttribute('aria-hidden', String(index !== this.index));
      });
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      if (announce) this.status.textContent = `Reseña ${this.index + 1} de ${this.slides.length}`;
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
}
